export const SET_THEME = 'SET_THEME';
export const SET_USER_FILTER = 'SET_USER_FILTER';
export const CLEAR_USER_FILTER = 'CLEAR_USER_FILTER';
